import React from 'react';
import { Check, X } from 'lucide-react';

const ComparisonTable = () => {
  const features = [
    { feature: 'Time Required', manual: '4-8 hours daily', sahara: '0 hours - Fully Automated', highlight: true },
    { feature: 'Experience Needed', manual: 'Years of learning', sahara: 'None - AI does the work', highlight: true },
    { feature: 'Emotional Trading', manual: 'High risk of mistakes', sahara: 'Zero emotions - Pure logic', highlight: true },
    { feature: 'Strategy Analysis', manual: 'Manual research', sahara: 'AI filters 1000s strategies', highlight: false },
    { feature: 'Risk Management', manual: 'Self-managed', sahara: 'AI-powered monitoring', highlight: false },
    { feature: 'Performance Tracking', manual: 'Manual spreadsheets', sahara: 'Real-time dashboard', highlight: false },
    { feature: 'Win Rate Optimization', manual: 'Trial & error', sahara: 'AI optimization', highlight: false },
    { feature: 'Profit Potential', manual: 'Inconsistent', sahara: 'Proven strategies', highlight: false }
  ];

  return (
    <div className="comparison-table-wrapper">
      <h2 className="comparison-title">Manual Trading vs Sahara AI Copytrade</h2>
      <p className="comparison-subtitle">See why smart traders are making the switch</p>
      
      <div className="comparison-table">
        <div className="comparison-header">
          <div className="header-cell feature-col">Feature</div>
          <div className="header-cell manual-col">
            <X className="header-icon negative" />
            Manual Trading
          </div>
          <div className="header-cell sahara-col">
            <Check className="header-icon positive" />
            Sahara AI Copytrade
          </div>
        </div>

        {features.map((item, index) => (
          <div key={index} className={`comparison-row ${item.highlight ? 'highlighted' : ''}`}>
            <div className="cell feature-cell">{item.feature}</div>
            <div className="cell manual-cell">{item.manual}</div>
            <div className="cell sahara-cell">{item.sahara}</div>
          </div>
        ))}
      </div>

      <div className="comparison-cta">
        <p className="cta-text">Join 15,000+ traders who switched to automated trading</p>
      </div>
    </div>
  );
};

export default ComparisonTable;
